export default {
  isWhitelabel: (state) => state.whitelabelConfig !== undefined,
}
